export default {
    methods: {
        async ticketAndamento(id, andamento) {
            await this.$Modal.remove();
            return new Promise((resolve, reject) => {
                this.$Modal.confirm({
                    closable: true,
                    title: `Ticket: ${id} - Alterar andamento`,
                    okText: "Confirmar",
                    cancelText: "Cancelar",
                    onOk: async () => {
                        try {
                            const {data} = await this.$axios.put(`ticket/${id}/alterarAndamento`, { andamento });
                            resolve(data);
                        } catch (error) {
                            reject(error)
                        }
                    }
                });
            });
        },
        async ticketEmTestes(ticket,form) {
            this.$refs.drawer.$refs.form.carregar = true
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    const id = ticket.id_ticket
                    if (form.descricao_andamento.length < 20) {
                        this.$Message.error(`Descrição muito curta`);
                        this.$refs.drawer.$refs.form.carregar = false
                        return
                    }
                    if (ticket.tipo_id == 32 && form.causa_bug.length == 0) {
                        this.$Message.error(`Informe a causa do bug`);
                        this.$refs.drawer.$refs.form.carregar = false
                        return
                    }
                    try {
                        this.$axios.put(`ticket/${id}/alterarAndamento`,form)
                        this.$Message.success(`Registro salvo com sucesso`)
                        this.show_andamento = false
                        resolve()
                    } catch (error) {
                        this.$refs.drawer.$refs.form.carregar = false
                        reject(error)
                    }                    
                }, 500);
            });
        },
        async ticketNaoAprovado(ticket,form) {
            this.$refs.drawer.$refs.form.carregar = true
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    const id = ticket.id_ticket
                    if (form.descricao_andamento.length < 20) {
                        this.$Message.error(`Descrição muito curta`)
                        this.$refs.drawer.$refs.form.carregar = false
                        return
                    }
                    if (ticket.tipo_id == 32 && form.causa_bug.length === 0) {
                        this.$Message.error(`Informe o motivo`)
                        this.$refs.drawer.$refs.form.carregar = false
                        return
                    }
                    try {
                        this.$axios.put(`ticket/${id}/retrocederAndamento`, form)
                        this.$Message.success(`Registro salvo com sucesso`)
                        this.show_andamento = false
                        resolve()
                    } catch (error) {
                        this.$refs.drawer.$refs.form.carregar = false
                        reject(error)
                    }                    
                }, 500);

            })
        },
        async fecharTicket(ticket,form) {
            this.$refs.drawer.$refs.form.carregar = true
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    const id = ticket.id_ticket
                    const assunto = 'Ticket Fechado - '+id
                    if (form.descricao_andamento.length < 20) {
                        this.$Message.error(`Observação muito curta`)
                        this.$refs.drawer.$refs.form.carregar = false
                        return
                    }
                    try {
                        this.$axios.put(`ticket/${id}/fechar`,
                                    {
                                        observacao:form.descricao_andamento, 
                                        descricao_andamento: form.descricao_andamento,
                                        mensagem:form.descricao_andamento, 
                                        assunto: assunto
                                    }
                        )
                        this.$Message.success(`Registro salvo com sucesso`)
                        this.show_andamento = false
                        resolve()
                    } catch (error) {
                        this.$refs.drawer.$refs.form.carregar = false
                        reject(error)
                    }                   
                }, 500);
            })
        },
        async resolverTicket(ticket,form) {
            this.$refs.drawer.$refs.form.carregar = true
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    const id = ticket.id_ticket
                    const assunto = 'Ticket Finalizado - '+id
                    if (form.descricao_andamento.length < 20) {
                        this.$Message.error(`Observação muito curta`)
                        this.$refs.drawer.$refs.form.carregar = false
                        return
                    }
                    try {
                        this.$axios.put(
                            `ticket/${id}/resolver`,
                            {
                                observacao:form.descricao_andamento, 
                                descricao_andamento: form.descricao_andamento,
                                mensagem:form.descricao_andamento, 
                                assunto: assunto
                            }
                        )
                        this.$Message.success(`Registro salvo com sucesso`)
                        this.show_andamento = false
                        resolve()
                    } catch (error) {
                        this.$refs.drawer.$refs.form.carregar = false
                        reject(error)
                    }
                }, 500)
            });
        },
        async associarTicket(ticket) {
            await this.$Modal.remove();
            return new Promise(async (resolve, reject) => {

                const id = ticket.id_ticket;
                let id_associado = 0;
                this.$Modal.confirm({
                    loading: true,
                    title: `Associar Ticket ${id} (${ticket.resumo.substring(0, 15)}...)`,
                    okText: "Confirmar",
                    cancelText: "Cancelar",
                    render: h => h(
                        "TicketsSelect",
                        {
                            props: {
                                exclude: id,
                                value: id_associado,
                                exibirQuarentena: ticket.status === 0
                            },
                            on: {
                                input: val => {
                                    id_associado = val;
                                }
                            }
                        }
                    ),
                    onOk: async function () {
                        if (id_associado === 0) {
                            this.buttonLoading = false;
                            this.$Message.error(`Ticket não selecionado`);
                            return;
                        }
                        try {
                            await this.$axios.put(`ticket/${id}/associar`, {id_associado});
                            this.$Modal.remove();
                            resolve({id_associado});
                        } catch (error) {
                            reject({error});
                        }
                    }
                });
            });
        },
        async reabrirTicket(ticket) {
            await this.$Modal.remove();
            return new Promise((resolve, reject) => {
                const id = ticket.id_ticket;
                this.$Modal.confirm({
                    loading: true,
                    title: `Reabrir Ticket ${id} (${ticket.resumo.substring(0, 15)}...)`,
                    okText: "Confirmar",
                    cancelText: "Cancelar",
                    onOk: async () => {
                        try {
                            await this.$axios.put(`ticket/${id}/reabrir`);
                            this.$Modal.remove();
                            resolve();
                        } catch (error) {
                            reject({error});
                        }
                    }
                });
            });
        },
        async desassociarTicket(ticket) {
            await this.$Modal.remove();
            return new Promise((resolve, reject) => {
                const id = ticket.id_ticket;
                this.$Modal.confirm({
                    loading: true,
                    title: `Desassociar Ticket ${id} (${ticket.resumo.substring(0, 15)}...)`,
                    okText: "Confirmar",
                    cancelText: "Cancelar",
                    onOk: async () => {
                        try {
                            await this.$axios.put(`ticket/${id}/desassociar`);
                            this.$Modal.remove();
                            resolve();
                        } catch (error) {
                            reject({error});
                        }
                    }
                });
            });
        }
    }
}
